import {GetFiveStars} from 'domain/usecases';
import {RemoteGetFiveStars} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {FiveStarsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetFiveStars = (): GetFiveStars =>
	new RemoteGetFiveStars(
		makeBFFApiUrl(FiveStarsFlowEndPoints.fiveStarsFlow),
		makeAuthorizeHttpClientDecorator(),
	);
